// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3VWyZ","actions":"GroupTable_actions__3Jyqn","deleteModalFooter":"GroupTable_deleteModalFooter__Fwxo1"};